import React from 'react';

const MyReview = () => {
    return (
        <div>
            <h3>My review</h3>
        </div>
    );
};

export default MyReview;